module.exports = __webpack_public_path__ + "static/media/ethereum-logo.14985a4c.png";